// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PS1g","label":"styles_label__3ezMh"};